export const FETCH_PERMISSIONS_PENDING = 'FETCH_PERMISSIONS_PENDING';
export const FETCH_PERMISSIONS_REJECTED = 'FETCH_PERMISSIONS_REJECTED';
export const FETCH_PERMISSIONS_FULFILLED = 'FETCH_PERMISSIONS_FULFILLED';


// WEBPACK FOOTER //
// ./src/constants/permissions.js